import { ThemeProvider, createTheme, useTheme } from "@mui/material/styles";
import useHelp from "../../help/useHelp";
import { useState, useRef, useEffect, useMemo } from "react";
import { Outlet, useLocation } from "react-router-dom-v5-compat";
import { experimentalStyled } from "@mui/material";
import DocsNavbar from "./DocsNavbar";
import DocsSidebar from "./DocsSidebar";

const DocsLayoutWrapper = experimentalStyled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  display: "flex",
  height: "100%",
  overflow: "hidden",
  paddingTop: 64,
  [theme.breakpoints.up("lg")]: {
    paddingLeft: 256,
  },
}));

const DocsLayoutContainer = experimentalStyled("div")({
  flex: "1 1 auto",
  overflow: "auto",
});

const DocsLayout = () => {
  const [isSidebarMobileOpen, setIsSidebarMobileOpen] = useState(false);

  const { pathname } = useLocation();
  const scroller = useRef(null);
  const baseTheme = useTheme();
  const { brand } = useHelp();
  const helpTheme = useMemo(
    () =>
      createTheme(baseTheme, { palette: { primary: { main: brand.color } } }),
    [baseTheme, brand.color]
  );
  useEffect(() => {
    if (scroller.current) scroller.current.scrollTop = 0;
  }, [pathname]);
  return (
    <ThemeProvider theme={helpTheme}>
      <DocsNavbar onSidebarMobileOpen={() => setIsSidebarMobileOpen(true)} />
      <DocsSidebar
        onMobileClose={() => setIsSidebarMobileOpen(false)}
        openMobile={isSidebarMobileOpen}
      />
      <DocsLayoutWrapper>
        <DocsLayoutContainer ref={scroller}>
          <Outlet />
        </DocsLayoutContainer>
      </DocsLayoutWrapper>
    </ThemeProvider>
  );
};

export default DocsLayout;
